import { Component, OnInit } from '@angular/core';
import { DsButtonVariants, DsColors, Icons, IconScale, IconStyles } from '@levelaccess/design-system';

import { RoutingService } from '../../../services/routing.service';
import { ModalService } from '../../../services/modal.service';
import { FeatureFlagCollection, revertFlag } from '../../../../../shared/interfaces/feature-flag.interface';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  standalone: false,
})
export class NotFoundComponent implements OnInit {
  public pageTitle: string;
  public readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;
  public readonly DsColors: typeof DsColors = DsColors;
  public readonly FeatureFlagCollection: typeof FeatureFlagCollection = FeatureFlagCollection;
  public readonly Icons: typeof Icons = Icons;
  public readonly IconScale: typeof IconScale = IconScale;
  public readonly IconStyles: typeof IconStyles = IconStyles;
  public readonly revertFlag: typeof revertFlag = revertFlag;

  constructor(
    private routingService: RoutingService,
    private modalService: ModalService,
  ) {}

  public ngOnInit(): void {
    this.pageTitle = this.routingService.getPageTitle();
    this.modalService.closeModal();
  }
}
